<div id="login" class="view">
    <nav class="navbar fixed-top" id="mainnav">
        <div class="container-fluid">
            <a class="navbar-brand" routerLink="/">Dynalearn</a>
        </div>
    </nav>
    <div id="maincontent" class="container-fluid">
        <form novalidate #loginform="ngForm">
            <div id="loginpanel" class="card border-primary">
                <div class="card-header">
                    <h3>{{'LOGIN.HEADER' | translate}}</h3>
                </div>

                @switch (stap()) {
                    @case ('credentials') {
                        <div class="card-body">
                            <div class="mb-3">
                                <input id="loginusername" name="username" type="text"
                                       [(ngModel)]="formulier.username" class="form-control"
                                       [placeholder]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                       [title]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                       autocomplete="off" required tabindex="1" autofocus>
                            </div>
                            <div class="mb-3">
                                <input id="loginpassword" name="password" type="password"
                                       [(ngModel)]="formulier.password" class="form-control"
                                       [placeholder]="'LOGIN.WACHTWOORD' | translate"
                                       [title]="'LOGIN.WACHTWOORD' | translate"
                                       autocomplete="off" required>
                                <a id="naarwachtwoordvergeten" href="javascript:void(0)"
                                   (click)="wachtwoordVergeten()">{{'WACHTWOORDVERGETEN.LINK' | translate}}</a>
                            </div>
                            <div class="text-center">
                                <button type="button" class="btn btn-primary"
                                        [disabled]="loginform.invalid || bezig()"
                                        (click)="login()">{{'LOGIN.INLOGGEN' | translate}}</button>
                            </div>
                            <div class="stappen">
                                <div class="row">
                                    <div class="col-6 text-start">
                                        <a id="naarcode" href="javascript:void(0)"
                                           (click)="naarCode()">{{'LOGIN.CODELOGIN' | translate}}</a>
                                    </div>
                                    <div class="col-6 text-end">
                                        <a id="naaradvanced" href="javascript:void(0)"
                                           (click)="naarAdvanced()">{{'LOGIN.ADVANCED' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="formfeedback">{{feedback() | translate}}</div>
                        </div>
                    }

                    @case ('domein') {
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="kiesdomein">{{'LOGIN.DOMEIN' | translate}}</label>
                                <select id="kiesdomein" name="domein" class="form-select"
                                        [(ngModel)]="formulier.domein" required>
                                    @for (dom of kiesdomein(); track dom) {
                                        <option [value]="dom">{{dom}}</option>
                                    }
                                </select>
                            </div>
                            <div class="text-center">
                                <button type="button" class="btn btn-primary"
                                        [disabled]="loginform.invalid || bezig()"
                                        (click)="login()">{{'LOGIN.INLOGGEN' | translate}}</button>
                            </div>
                            <div class="stappen">
                                <div class="row">
                                    <div class="col-6 text-start">
                                        <a id="naarbegin" href="javascript:void(0)"
                                           (click)="naarBegin()">{{'LOGIN.BEGIN' | translate}}</a>
                                    </div>
                                    <div class="col-6 text-end">
                                        <a id="naaradvanced" href="javascript:void(0)"
                                           (click)="naarAdvanced()">{{'LOGIN.ADVANCED' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="formfeedback">{{feedback() | translate}}</div>
                        </div>
                    }

                    @case ('project') {
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="kiesproject">{{'LOGIN.PROJECT' | translate}}</label>
                                <select id="kiesproject" name="project" class="form-select"
                                        [(ngModel)]="formulier.project" required>
                                    @for (pr of kiesproject(); track pr) {
                                        <option [value]="pr">{{pr}}</option>
                                    }
                                </select>
                            </div>
                            <div class="text-center">
                                <button type="button" class="btn btn-primary"
                                        [disabled]="loginform.invalid || bezig()"
                                        (click)="login()">{{'LOGIN.INLOGGEN' | translate}}</button>
                            </div>
                            <div class="stappen">
                                <div class="row">
                                    <div class="col-6 text-start">
                                        <a id="naarbegin" href="javascript:void(0)"
                                           (click)="naarBegin()">{{'LOGIN.BEGIN' | translate}}</a>
                                    </div>
                                    <div class="col-6 text-end">
                                        <a id="naaradvanced" href="javascript:void(0)"
                                           (click)="naarAdvanced()">{{'LOGIN.ADVANCED' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="formfeedback">{{feedback() | translate}}</div>
                        </div>
                    }

                    @default {
                        @if (stap() === 'advanced' || stap() === 'fixed_advanced') {
                            <div class="card-body">
                                @if (metDomeinveld()) {
                                    <div class="mb-3">
                                        <input id="logindomein" name="domein" type="text"
                                               [(ngModel)]="formulier.domein" class="form-control"
                                               [placeholder]="'LOGIN.DOMEIN' | translate"
                                               [title]="'LOGIN.DOMEIN' | translate"
                                               autocomplete="off" required>
                                    </div>
                                    <div class="mb-3">
                                        <input id="loginproject" name="project" type="text"
                                               [(ngModel)]="formulier.project" class="form-control"
                                               [placeholder]="'LOGIN.PROJECT' | translate"
                                               [title]="'LOGIN.PROJECT' | translate"
                                               autocomplete="off" required>
                                    </div>
                                }
                                <div class="mb-3">
                                    <input id="loginusername" name="username" type="text"
                                           [(ngModel)]="formulier.username" class="form-control"
                                           [placeholder]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                           [title]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                           autocomplete="off" required>
                                </div>
                                <div class="mb-3">
                                    <input id="loginpassword" name="password" type="password"
                                           [(ngModel)]="formulier.password" class="form-control"
                                           [placeholder]="'LOGIN.WACHTWOORD' | translate"
                                           [title]="'LOGIN.WACHTWOORD' | translate"
                                           autocomplete="off" required>
                                    <a id="naarwachtwoordvergeten" href="javascript:void(0)"
                                       (click)="wachtwoordVergeten()">{{'WACHTWOORDVERGETEN.LINK' | translate}}</a>
                                </div>
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary"
                                            [disabled]="loginform.invalid || bezig()"
                                            (click)="login()">{{'LOGIN.INLOGGEN' | translate}}</button>
                                </div>
                                <div class="stappen">
                                    <div class="row">
                                        <div class="col-6 text-start">
                                            <a id="naarcode" href="javascript:void(0)"
                                               (click)="naarCode()">{{'LOGIN.CODELOGIN' | translate}}</a>
                                        </div>
                                        <div class="col-6 text-end">
                                            <a id="naarnormaal" href="javascript:void(0)"
                                               (click)="naarNormaal()">{{'LOGIN.NORMAAL' | translate}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="formfeedback">{{feedback() | translate}}</div>
                            </div>
                        } @else {
                            <div class="card-body">
                                @if (stap() === 'bevestigaccount') {
                                    <p>{{'LOGIN.MAAK_ACCOUNT_AAN_UITLEG' | translate}}</p>
                                }
                                <div class="mb-3">
                                    <input id="logincode" name="code" type="text"
                                           [(ngModel)]="formulier.code" class="form-control"
                                           [disabled]="stap() === 'bevestigaccount'"
                                           [placeholder]="'LOGIN.CODE' | translate"
                                           [title]="'LOGIN.CODE' | translate"
                                           autocomplete="off" required tabindex="1" autofocus>
                                </div>
                                <div class="mb-3">
                                    <input id="loginusername" name="username" type="email"
                                           [(ngModel)]="formulier.username" class="form-control"
                                           [disabled]="stap() === 'bevestigaccount'"
                                           [placeholder]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                           [title]="'LOGIN.GEBRUIKERSNAAM' | translate"
                                           autocomplete="off" required>
                                </div>
                                @if (stap() === 'bevestigaccount') {
                                    <div class="mb-3">
                                        <input id="loginbevestigingscode" name="bevestigingscode" type="text"
                                               [(ngModel)]="formulier.bevestigingscode" class="form-control"
                                               [placeholder]="'LOGIN.BEVESTIGINGSCODE' | translate"
                                               [title]="'LOGIN.BEVESTIGINGSCODE' | translate"
                                               autocomplete="off" required>
                                    </div>
                                    <div class="mb-3">
                                        <input id="loginpassword" name="password" type="password" minlength="6"
                                               [(ngModel)]="formulier.password" class="form-control"
                                               [placeholder]="'LOGIN.WACHTWOORD' | translate"
                                               [title]="'LOGIN.WACHTWOORD' | translate"
                                               autocomplete="off" required>
                                        @if (formulier.password && formulier.password.length < 6) {
                                            <p class="text-warning">{{'WACHTWOORDVERGETEN.WIJZIG.TEKORT' | translate}}</p>
                                        }
                                    </div>
                                    <div class="mb-3">
                                        <input id="loginpassword2" name="password2" type="password" minlength="6"
                                               [(ngModel)]="formulier.password2" class="form-control"
                                               [placeholder]="'LOGIN.WACHTWOORD2' | translate"
                                               [title]="'LOGIN.WACHTWOORD2' | translate"
                                               autocomplete="off" required>
                                        @if (!wachtwoordenGelijk()) {
                                            <p class="text-warning">{{'WACHTWOORDVERGETEN.WIJZIG.ONGELIJK' | translate}}</p>
                                        }
                                    </div>
                                    <div class="mb-3">
                                        <input id="loginnaam" name="naam" type="text" minlength="4" maxlength="40"
                                               [(ngModel)]="formulier.naam" class="form-control"
                                               [placeholder]="'LOGIN.DISPLAYNAAM' | translate"
                                               [title]="'LOGIN.DISPLAYNAAM' | translate" required>
                                    </div>
                                } @else {
                                    <p>{{'LOGIN.CODE_UITLEG' | translate}}</p>
                                }
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary"
                                            [disabled]="loginform.invalid || !wachtwoordenGelijk() || bezig()"
                                            (click)="aanmeldenCode()">{{'LOGIN.AANMELDEN' | translate}}</button>
                                </div>
                                <div class="stappen">
                                    <div class="row">
                                        <div class="col-6 text-start">
                                            @if (stap() === 'bevestigaccount') {
                                                <a id="naarcode" href="javascript:void(0)"
                                                   (click)="naarCode()">{{'LOGIN.TERUG_CODE' | translate}}</a>
                                            }
                                        </div>
                                        <div class="col-6 text-end">
                                            <a id="naarnormaal" href="javascript:void(0)"
                                               (click)="naarNormaal()">{{'LOGIN.WACHTWOORDLOGIN' | translate}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="formfeedback">{{feedback() | translate}}</div>
                            </div>
                        }
                    }
                }
            </div>
        </form>
    </div>

    <footer id="mainfooter">
        <div class="container-fluid">
            <div class="row">
                <div class="footercol col-sm-6 text-start">
                    <span class="fa-solid fa-house"></span>&nbsp;&nbsp;DynaLearn Create v{{versie}}
                </div>
            </div>
        </div>
    </footer>
</div>
